// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateView_date-view__syTK7 {
  font-size: var(--text-lg);
  display: flex;
  align-items: center;
  gap: 1rem;
}

.DateView_date-view__day__pDTr1 {
  color: #000;
  font-weight: 700;
}

.DateView_date-view__date__9aquZ {
  color: var(--gray-dark);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/DateView/DateView.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".date-view {\n  font-size: var(--text-lg);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.date-view__day {\n  color: #000;\n  font-weight: 700;\n}\n\n.date-view__date {\n  color: var(--gray-dark);\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date-view": `DateView_date-view__syTK7`,
	"date-view__day": `DateView_date-view__day__pDTr1`,
	"date-view__date": `DateView_date-view__date__9aquZ`
};
export default ___CSS_LOADER_EXPORT___;
